<div class="container-fluid p-3">
    <p class="peripheral-header"><b>Edit Peripheral ID</b></p>
    <!-- <h5 class="mb-3">Edit Peripheral ID</h5> -->
  <p class="text-muted mb-2">Update the peripheral id for this device.</p>

  <form [formGroup]="peripheralForm" (ngSubmit)="onUpdate()">
    <label class="field-label" for="peripheralId">Peripheral ID</label>
    <input
      id="peripheralId"
      formControlName="peripheralId"
      type="text"
      class="form-control custom-input mb-2"
      [class.is-invalid]="peripheralIdErrorMessage"
      autocomplete="off"
      spellcheck="false"
      [attr.aria-invalid]="peripheralIdErrorMessage ? true : null"
      aria-describedby="peripheralIdHint peripheralIdError">
    <p id="peripheralIdHint" class="hint-text">{{ peripheralIdHint }}</p>
    @if (peripheralIdErrorMessage) {
      <p id="peripheralIdError" class="error-message" role="alert">{{ peripheralIdErrorMessage }}</p>
    }

    <div class="d-flex justify-content-end gap-2 mt-3 mb-4">
      <button type="button" mat-stroked-button mat-dialog-close style="color: #3A6570">Cancel</button>
      <button
              type="submit"
              class="btn-confirm"
              [disabled]="!peripheralForm.valid || isSubmitting">Update</button>
    </div>
  </form>
</div>
